// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Merchants_establishments__2N56e","header":"Merchants_header__v7tzU","tableHeader":"Merchants_tableHeader__NwqPq"};